import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { initialTheme } from './lib/theme.jsx'
import './index.css'

/*
 * The theme attribute is set here, before React mounts, rather than inside
 * ThemeProvider's own effect. An effect only runs after the first paint, so
 * doing it there would draw one light-theme frame and then flip to dark a
 * moment later — visible as a flash on every load for anyone who has chosen
 * dark. Reading the same storage key ThemeProvider reads keeps the two in
 * sync without a second source of truth.
 */
document.documentElement.setAttribute('data-theme', initialTheme())

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
